module.exports = __webpack_public_path__ + "static/media/Site_Scuba.81bcb180.jpg";